export default "__VITE_ASSET__CxOURlKt__"